/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CreateNotificationScheduleRequest } from "./CreateNotificationScheduleRequest";
import {
    CreateNotificationScheduleRequestFromJSON,
    CreateNotificationScheduleRequestFromJSONTyped,
    CreateNotificationScheduleRequestToJSON,
} from "./CreateNotificationScheduleRequest";

/**
 *
 * @export
 * @interface CreateNotificationPreferenceRequest
 */
export interface CreateNotificationPreferenceRequest {
    /**
     *
     * @type {number}
     * @memberof CreateNotificationPreferenceRequest
     */
    userAccountId?: number;
    /**
     *
     * @type {Array<string>}
     * @memberof CreateNotificationPreferenceRequest
     */
    deviceGroupTags?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof CreateNotificationPreferenceRequest
     */
    deviceIdentities?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof CreateNotificationPreferenceRequest
     */
    notificationMethods?: Array<CreateNotificationPreferenceRequestNotificationMethodsEnum>;
    /**
     *
     * @type {Array<string>}
     * @memberof CreateNotificationPreferenceRequest
     */
    notificationTypes?: Array<CreateNotificationPreferenceRequestNotificationTypesEnum>;
    /**
     *
     * @type {string}
     * @memberof CreateNotificationPreferenceRequest
     */
    notificationFrequency?: CreateNotificationPreferenceRequestNotificationFrequencyEnum;
    /**
     *
     * @type {CreateNotificationScheduleRequest}
     * @memberof CreateNotificationPreferenceRequest
     */
    schedule?: CreateNotificationScheduleRequest;
}

/**
 * @export
 */
export const CreateNotificationPreferenceRequestNotificationMethodsEnum = {
    Unknown: "Unknown",
    Email: "Email",
    Sms: "SMS",
    PushNotification: "PushNotification",
} as const;
export type CreateNotificationPreferenceRequestNotificationMethodsEnum =
    (typeof CreateNotificationPreferenceRequestNotificationMethodsEnum)[keyof typeof CreateNotificationPreferenceRequestNotificationMethodsEnum];

/**
 * @export
 */
export const CreateNotificationPreferenceRequestNotificationTypesEnum = {
    Unknown: "Unknown",
    FaultedStateDevice: "FaultedStateDevice",
    OfflineStateDevice: "OfflineStateDevice",
    UnknownStateDevice: "UnknownStateDevice",
    NonOperationalDevice: "NonOperationalDevice",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    EnergyPriceChargingResumed: "EnergyPriceChargingResumed",
    Warning: "Warning",
    FrequentFaultsWarning: "FrequentFaultsWarning",
    ShortDurationWarning: "ShortDurationWarning",
    NoActivityWarning: "NoActivityWarning",
    ZerokWhWarning: "ZerokWhWarning",
    PowerLossWarning: "PowerLossWarning",
    LowEnergyMidSessionWarning: "LowEnergyMidSessionWarning",
} as const;
export type CreateNotificationPreferenceRequestNotificationTypesEnum =
    (typeof CreateNotificationPreferenceRequestNotificationTypesEnum)[keyof typeof CreateNotificationPreferenceRequestNotificationTypesEnum];

/**
 * @export
 */
export const CreateNotificationPreferenceRequestNotificationFrequencyEnum = {
    Unknown: "Unknown",
    RealTime: "RealTime",
    Scheduled: "Scheduled",
} as const;
export type CreateNotificationPreferenceRequestNotificationFrequencyEnum =
    (typeof CreateNotificationPreferenceRequestNotificationFrequencyEnum)[keyof typeof CreateNotificationPreferenceRequestNotificationFrequencyEnum];

/**
 * Check if a given object implements the CreateNotificationPreferenceRequest interface.
 */
export function instanceOfCreateNotificationPreferenceRequest(
    value: object,
): value is CreateNotificationPreferenceRequest {
    return true;
}

export function CreateNotificationPreferenceRequestFromJSON(
    json: any,
): CreateNotificationPreferenceRequest {
    return CreateNotificationPreferenceRequestFromJSONTyped(json, false);
}

export function CreateNotificationPreferenceRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CreateNotificationPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        deviceIdentities:
            json["deviceIdentities"] == null
                ? undefined
                : json["deviceIdentities"],
        notificationMethods:
            json["notificationMethods"] == null
                ? undefined
                : json["notificationMethods"],
        notificationTypes:
            json["notificationTypes"] == null
                ? undefined
                : json["notificationTypes"],
        notificationFrequency:
            json["notificationFrequency"] == null
                ? undefined
                : json["notificationFrequency"],
        schedule:
            json["schedule"] == null
                ? undefined
                : CreateNotificationScheduleRequestFromJSON(json["schedule"]),
    };
}

export function CreateNotificationPreferenceRequestToJSON(
    value?: CreateNotificationPreferenceRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        userAccountId: value["userAccountId"],
        deviceGroupTags: value["deviceGroupTags"],
        deviceIdentities: value["deviceIdentities"],
        notificationMethods: value["notificationMethods"],
        notificationTypes: value["notificationTypes"],
        notificationFrequency: value["notificationFrequency"],
        schedule: CreateNotificationScheduleRequestToJSON(value["schedule"]),
    };
}
